import { render, staticRenderFns } from "./postion.vue?vue&type=template&id=7c244a7d&scoped=true&"
import script from "./postion.vue?vue&type=script&lang=js&"
export * from "./postion.vue?vue&type=script&lang=js&"
import style0 from "./postion.vue?vue&type=style&index=0&id=7c244a7d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c244a7d",
  null
  
)

export default component.exports